import { render, staticRenderFns } from "./_topic.vue?vue&type=template&id=602f2edd"
import script from "./_topic.vue?vue&type=script&lang=js"
export * from "./_topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports